<template>
  <video
    class="video"
    @mouseover="mouseOver"
    @mouseleave="mouseLeave"
    @ended="videoEnded"
    muted
    autoplay
    loop
    playsinline
    :src="videoObjectURL"
  >
  </video>
</template>

<script>
import Ajax from '@/services/Ajax';

const ajax = new Ajax({});

export default {
  props: {
    video: Object,
  },
  data() {
    return {
      videoObjectURL: this.video.path,
      isMouseStillOver: false,
      videoIsLoading: false,
    };
  },
  methods: {
    mouseOver(e) {
      this.isMouseStillOver = true;
      if (this.videoIsLoading === true) return;
      if (this.videoObjectURL === null) {
        this.videoIsLoading = true;
        this.preloadVideo(this.video.path || this.video.url)
          .then((videoObjectUrl) => {
            this.videoObjectURL = window.URL.createObjectURL(videoObjectUrl);
            this.videoIsLoading = false;
          })
          .then(() => {
            if (this.isMouseStillOver) {
              this.$emit('videoOver', e.target);
            }
          })
          .catch(() => {
            this.videoObjectURL = null;
            this.videoIsLoading = false;
          });
      } else {
        this.$emit('videoOver', e.target);
      }
    },
    mouseLeave(e) {
      this.isMouseStillOver = false;
      if (!this.videoIsLoading && this.videoObjectURL) {
        this.$emit('videoLeave', e.target);
      }
    },
    videoEnded(e) {
      if (e.target.ended) {
        this.$emit('videoEnded', e.target);
      }
    },
    preloadVideo(src) {
      return ajax.request('GET', src, null, {}, { responseType: 'blob' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Video.vue